import "core-js/modules/es.string.fixed.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

_pushScopeId("data-v-86ef334c");

var _hoisted_1 = {
  class: "header-wrapper"
};

_popScopeId();

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_nav_bar = _resolveComponent("van-nav-bar");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
    border: $props.border,
    fixed: $props.fixed,
    onClickLeft: $options.onClickLeft,
    "left-arrow": "",
    class: _normalizeClass({
      resetColor: $props.headerBackground
    }),
    style: _normalizeStyle({
      background: $props.headerBackground,
      paddingTop: $options.fixTop + 'px'
    }),
    title: $options.headerTitle,
    "safe-area-inset-top": ""
  }, {
    right: _withCtx(function () {
      return [_createElementVNode("div", {
        class: "header-share",
        onClick: _cache[0] || (_cache[0] = function () {
          return $options.onClickRight && $options.onClickRight.apply($options, arguments);
        })
      }, "···")];
    }),
    _: 1
  }, 8, ["border", "fixed", "onClickLeft", "class", "style", "title"])]);
}